// extracted by mini-css-extract-plugin
module.exports = {"redPercent":"cn_redPercent__Dk5qG"};